import React, { ReactNode, useContext, useMemo, useState } from "react";
import {
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { langStore } from "@noli/business";

import { genBlock } from "@/utils/bem";

import { WordEntityTypeWithParentKeys, WordTableItemType } from "../type";

import { ExpandableText } from "../ExpandableText";
import { SubclassMenu } from "../Subclass";
import { KeywordList } from "../KeywordList";

import "./style.scss";
import { WordTableContext } from "../context";

export const block = genBlock("c-word-table-cell");
/**
 * 一级选择项
 * @returns
 */
const IWordTableCell: React.FC<{
  data: WordTableItemType<WordEntityTypeWithParentKeys>;
}> = ({ data }) => {
  const { nameDict } = useContext(WordTableContext);
  const [open, setOpen] = useState(false);
  const lang = langStore.tgt;

  const content = useMemo<ReactNode>(() => {
    if (data.subclass) {
      return <SubclassMenu list={data.subclass} />;
    }
    if (data.children) {
      return <KeywordList list={data.children} onClose={() => setOpen(false)} />;
    }
    return "";
  }, [data.subclass, data.children, setOpen]);

  return (
    <Flex className={block()} p="6px 12px" alignItems="center" pos="relative">
      <Popover
        isLazy
        placement="right"
        boundary={document.body}
        matchWidth
        preventOverflow
        flip
        isOpen={open}
        onClose={() => setOpen(false)}
        // eventListeners={false}
        modifiers={[
          {
            name: "topLogger",
            enabled: true,
            phase: "main",
            fn: ({ state }) => {
              state.styles.popper.zIndex = "1000";
              return state;
            },
          },
        ]}
      >
        <PopoverTrigger>
          <ExpandableText open={open} onClick={() => setOpen((open) => !open)}>
            {nameDict[data.key]?.[lang]}
          </ExpandableText>
        </PopoverTrigger>
        <Portal>
          <PopoverContent border="none" bg="#3A3A3A" rounded="12px" w="auto" zIndex={500}>
            <PopoverBody p="0px" w="fit-content">
              {content}
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    </Flex>
  );
};

export const WordTableCell = observer(IWordTableCell);
